import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

interface LoadingComponentProps {
  loadingText?: string;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ loadingText = 'Cargando...' }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2,
      }}
      open={true}
    >
      <CircularProgress color="primary" />
      <Typography variant="h6">{loadingText}</Typography>
    </Backdrop>
  );
};

export default LoadingComponent;